/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { teamAdvisorDtoSchema } from "./teamAdvisorDtoSchema.ts";
import { teamCoFounderDtoSchema } from "./teamCoFounderDtoSchema.ts";
import { teamHiringTimelineEntryDtoSchema } from "./teamHiringTimelineEntryDtoSchema.ts";
import { teamMemberDtoSchema } from "./teamMemberDtoSchema.ts";
import { teamPartnershipDtoSchema } from "./teamPartnershipDtoSchema.ts";
import { z } from "zod/v4";

export const teamSectionDtoSchema = z.object({
  get coFounders() {
    return z.array(teamCoFounderDtoSchema).optional();
  },
  get members() {
    return z.array(teamMemberDtoSchema).optional();
  },
  get hiringTimeline() {
    return z.array(teamHiringTimelineEntryDtoSchema).optional();
  },
  get advisors() {
    return z.array(teamAdvisorDtoSchema).optional();
  },
  get partnerships() {
    return z.array(teamPartnershipDtoSchema).optional();
  },
});
